module.exports = __webpack_public_path__ + "static/02a-6a6a403974564424ba24a172697e00eb.png";